import { CorporateBondId, TradeTicketId, OrderTicketId } from "@goodfill/domain-properties";
import { CustomerApplicationStepNumber } from "./App/account/customerApplication/form/customerApplicationSteps";

export const route = {
  // User Sign In/Up
  signIn: () => "/auth/sign-in",
  signUp: () => "/auth/sign-up",
  forgotPassword: () => "/auth/forgot-password",

  // Customer application
  customerApplication: (step: CustomerApplicationStepNumber) => `/account/application/step/${step}`,
  accountPortfolio: () => "/account/portfolio/portfolio",
  bondDetail: (bondId: CorporateBondId) => `/bonds/${bondId}`,
  dashboard: () => "/",
  registerConfirmation: (username: string) => `/auth/register-confirmation/${username}`,
  orderBuy: (bondId: CorporateBondId) => `/bonds/${bondId}/order/buy`,
  orderSell: (bondId: CorporateBondId, tradeTicketId: TradeTicketId) => `/bonds/${bondId}/order/sell/${tradeTicketId}`,
  orderModify: (bondId: CorporateBondId, orderId: OrderTicketId) => `/bonds/${bondId}/modify-order/${orderId}`,
  orderReceipt: (bondId: CorporateBondId, orderId: OrderTicketId) => `/bonds/${bondId}/receipt/${orderId}`,
  portfolio: () => "/account/portfolio/portfolio",
  orderList: () => "/account/portfolio/orderList",
  tradeHistory: () => "/account/portfolio/tradeHistory",
  paymentHistory: () => "/account/portfolio/paymentHistory",
  depositHistory: () => "/account/portfolio/depositHistory",
  corporateActions: () => "/account/portfolio/corporateActions",
  positions: (bondId: CorporateBondId) => `/account/portfolio/positions/${bondId}`,
  personalInformation: () => "/account/settings/personalInformation",
  financialInformation: () => "/account/settings/financialInformation",
  tradingPermissions: () => "/account/settings/tradingPermissions",
  bankInformation: () => "/account/settings/bankInformation",
  regulatoryInformation: () => "/account/settings/regulatoryInformation",
  transfer: () => "/account/settings/transfer",
  forms: () => "/account/settings/forms",
  applicationStatus: () => "/account/settings/applicationStatus",
  tradeTicketDetail: (tradeTicketId: TradeTicketId) => `/account/portfolio/tradeTicket/${tradeTicketId}`,
};

export const ABOUT_US_URL = `${import.meta.env.VITE_GOODFILL_URL}/about-us/`;
export const GETTING_STARTED_URL = `${import.meta.env.VITE_GOODFILL_URL}/help/`;
export const FEES_URL = `${import.meta.env.VITE_GOODFILL_URL}/cost/`;
export const BLOGS_URL = `${import.meta.env.VITE_GOODFILL_URL}/blog/`;
export const HELP_URL = `${import.meta.env.VITE_GOODFILL_URL}/help/`;
export const WEBINAR_URL = `${import.meta.env.VITE_GOODFILL_URL}/webinar/`;
export const DISCLOSURES_URL = `${import.meta.env.VITE_GOODFILL_URL}/disclosures/`;
